// extracted by css-extract-rspack-plugin
export default {"search":"search-BW658w","actionHeadingContainer":"actionHeadingContainer-zqr0wZ","clearTextButton":"clearTextButton-D982Xf text-base-semibold"};